<template>
  <div>
    <heads :more="showMore" :msg="title_msg"></heads>
    <van-tabs
      v-model="active"
      title-inactive-color="#333333"
      title-active-color="#ee2e2e"
      @click="clickTabs"
    >
      <van-tab title="课程">
        <van-list
          v-show="showList"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoadKC"
        >
          <div>
            <div v-for="(lesson,index) in kc_list" :key="index" @click="go_url1(lesson)">
              <datalists
                :type="2"
                :listType="5"
                :thumb="lesson.thumb"
                :atitle="lesson.lesson_name"
                :date="lesson.create_time"
              ></datalists>
            </div>
          </div>
        </van-list>
      </van-tab>
      <van-tab title="帖子">
        <van-list
          v-show="showList1"
          v-model="loading1"
          :finished="finished1"
          finished-text="没有更多了"
          @load="onLoadTZ"
        >
          <div v-for="(thread,index) in tz_list" :key="index" @click="go_url(thread)">
            <datalists
              :type="1"
              :listType="2"
              :thumb="thread.pic"
              :atitle="thread.title"
              :createTime="thread.create_time"
              :vNum="thread.view_num"
              :cNum="thread.reply_num"
            ></datalists>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import heads from '@/components/common/heads.vue'
import tool from '@/utils/tools.js'
import { get_kc_see, get_tz_see } from '@/api/my_user.js'
import datalists from '@/components/datalist'

export default {
  components: {
    heads,
    datalists
  },
  data () {
    return {
      title_msg: '浏览记录',
      active: 0,
      limit: 10,
      kc_page: 1,
      tz_page: 1,
      kc_count: 0,
      tz_count: 0,
      kc_list: [],
      tz_list: [],
      isshow: false,
      showList: true,
      loading: false,
      finished: false,
      showList1: true,
      loading1: false,
      finished1: false,
      showMore: true
    }
  },
  destroyed () {
    sessionStorage.removeItem('h_index')
  },
  mounted () {
    const index = sessionStorage.getItem('h_index') ? sessionStorage.getItem('h_index') : 0
    this.active = Number(index)
    this.get_kc_list()
    this.get_tz_list()
  },
  methods: {
    // 跳课程详情
    go_url1 (item) {
      const url = '/home?lesson_id='+item.lesson_id
      location.href = url
    },
    // 跳帖子详情
    go_url (item) {
      const url = '/bbsgroup/d/'+item.tid + '.html'
      location.href = url
    },
    formatDate (date) {
      var date = new Date(date * 1000)
      return tool.formatDate(date, 'yyyy-MM-dd')
    },
    clickTabs (val) {
      sessionStorage.setItem('h_index', val)
    },
    clicks () {
      if (this.isshow == false) {
        this.isshow = true
      } else {
        this.isshow = false
      }
    },
    onLoadKC () {
      if (this.kc_list.length >= this.kc_count) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true
      } else {
        this.kc_page++
        this.get_kc_list()
      }
    },
    onLoadTZ () {
      if (this.tz_list.length >= this.tz_count) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished1 = true
      } else {
        this.tz_page++
        this.get_tz_list()
      }
    },
    get_kc_list () {
      this.loading = true
      var params = {
        page: this.kc_page,
        limit: this.limit
      }
      get_kc_see(params).then(res => {
        this.loading = false
        const list = res.result.list ? res.result.list : []
        this.kc_count = res.result.count ? res.result.count : 0
        this.kc_list = [...this.kc_list, ...list]
      })
    },
    get_tz_list () {
      this.loading1 = true
      var params = {
        page: this.tz_page,
        limit: this.limit
      }
      get_tz_see(params).then(res => {
        this.loading1 = false
        const list = res.result.list ? res.result.list : []
        this.tz_count = res.result.count ? res.result.count : 0
        this.tz_list = [...this.tz_list, ...list]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.img_h {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 30px;
  top: 44px;
  z-index: 1;
}
// .eye_img {
//   width: 28px;
//   height: 18px;
//   position: absolute;
//   bottom: 45px;
//   left: 30px;
// }
// .kuang_img {
//   width: 24px;
//   height: 18px;
//   position: absolute;
//   bottom: 46px;
//   left: 200px;
// }

h4 {
  font-size: 30px;
  word-wrap: break-word;
  word-break: normal;
  width: 353px;
  // letter-spacing: 1px;
  padding: 37px 0 0 32px;
  line-height: 56px;
}
// .people_bro {
//   padding-left: 70px;
//   float: left;
//   color: #9b9b9b;
// }
// .people_gen {
//   float: left;
//   padding-left: 45px;
//   color: #9b9b9b;
//   position: absolute;
//   left: 190px;
//   bottom: 39px;
// }
// .bro_time {
//   float: right;
//   padding: 4px 33px 0 0;
//   color: #9b9b9b;
// }
.main {
  width: 100%;
  height: 276px;
  border-bottom: #efefef 1px solid;
  overflow: hidden;
  position: relative;
}
.ll_img {
  width: 279px;
  height: 157px;
  margin-top: 32px;
}
.main_top_left {
  float: left;
  width: 440px;
  height: 205px;
}
.main_top_right {
  float: left;
  overflow: hidden;
  height: 205px;
}
.thread {
  width: 100%;
  height: 280px;
  display: flex;
  justify-content: flex-end;
  border-bottom: #eee 1px solid;
}
.content {
  // width: calc(100% - 280px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  //自动计算剩余宽度
  flex: 1;
  .thread_title {
    margin: 30px 20px 30px 30px;
    font-size: 30px;
    color: #333333;
    line-height: 50px;
    word-break: break-all;
    word-wrap: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .bot_info {
    height: 50px;
    margin-bottom: 20px;
    line-height: 50px;
    .eye_img {
      margin-left: 30px;
      width: 28px;
      height: 18px;
    }
    .people_bro {
      margin-left: 8px;
      color: #999999;
      display: inline-block;
    }
    .kuang_img {
      margin-left: 30px;
      width: 24px;
      height: 18px;
    }
    .people_gen {
      margin-left: 8px;
      color: #999999;
      display: inline-block;
    }
  }
}
.right_box {
  width: 280px;
  height: 250px;
  margin-top: 30px;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .thumb {
    width: 100%;
    height: 158px;
  }
  .bot_time {
    height: 50px;
    margin-bottom: 20px;
    text-align: right;
    line-height: 50px;
    color: #999999;
  }
}
/deep/.van-tabs__nav--line {
  padding-bottom: 0px;
}
/deep/.van-tabs__wrap {
  border-bottom: 1px solid #eee;
}
/deep/.van-tabs__line {
  height: 4px;
  bottom: 0px;
  border-radius: 0;
}
</style>
